$('.placement-pages__item .button-stick').on('click', function(){

    $('.placement-pages__info').fadeOut();
    $(this).prev().fadeIn();

})

$('.placement-pages__info .is-close').on('click', function(){

    $('.placement-pages__info').fadeOut();

})